import dentalCariesReport from "./dentalCariesReport.vue";
export default dentalCariesReport;
